<template>
  <div>
    <div class="bottom bottm-fixed">
      <img v-lazy="bottomImg" alt="" @click="openDown()" class="bottomImg"/>
    </div>
     <!-- 占位 -->
    <div class="bottom">
      <img v-lazy="bottomImg" alt="" @click="openDown()" style="opacity: 0;" class="bottomImg"/>
    </div>
  </div>
</template>

<script>
import { get } from "lodash-es";
export default {
  name: "bottom",
  props: {
    bottomImg:{
      require: true
    }
  },
  methods: {
    openDown() {
      const app_address_fixed = get(this.$store.state, "webUrls.app_address_fixed", "");
      window.open(app_address_fixed)
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom {
  width: 100%;
  img {
    width: 100%;
    max-width: 750px;
  }
}
.bottm-fixed{
  position: fixed;
  bottom: 0px;
  z-index: 99;
}
</style>